import {IRouteDefinition, TRouteId} from '../../index';

/**
 * Conceptual search keys → box heading translation keys.
 * Route ids resolve into these via ROUTE_ID_TO_SEARCH_KEY (tabs/H1 keep route `label`).
 * Descriptions: `<heading>.description` via heading-v2 when the CMS key exists.
 */
const searchKeyMap: Record<string, string> = {
    'apiuser': 'apiuser.search',
    'apiuser.manualsource': 'apiuser.manualsource.search',
    'user': 'user.search',
    'user.manualsource': 'user.manualsource.search',
    'group': 'group.search',
    'group.manualsource': 'group.manualsource.search',
    'department': 'department.search',
    'department.manualsource': 'department.manualsource.search',
    'department.hierarchy': 'department.hierarchy.search',
    'forms.availableforms': 'forms.availableforms.search',
    'forms.formdata': 'forms.formdata.search',
    'forms.template': 'forms.template.search',
    'rulesets': 'rulesets.search',
    'messageflows': 'messageflows.search',
    'sync.template': 'sync.template.search',
    'permissions.collections': 'permissions.collections.search',
    'system.permission': 'system.permission.search',
    'import.history': 'import.history.search',
    'external.contact': 'external.contact.search',
};

/** Route id → conceptual key in `searchKeyMap`. */
const ROUTE_ID_TO_SEARCH_KEY: Partial<Record<TRouteId, keyof typeof searchKeyMap | string>> = {
    apiusersearch: 'apiuser',
    manualapiusersearch: 'apiuser.manualsource',
    usersearch: 'user',
    manualusersearch: 'user.manualsource',
    groupsearch: 'group',
    manualgroupsearch: 'group.manualsource',
    departmentsearch: 'department',
    manualdepartmentsearch: 'department.manualsource',
    departmenthierarchy: 'department.hierarchy',
    availableforms: 'forms.availableforms',
    formdatasearch: 'forms.formdata',
    formtemplatesearch: 'forms.template',
    rulesetsearch: 'rulesets',
    messageflowsearch: 'messageflows',
    synctemplatesearch: 'sync.template',
    systemaccessearch: 'permissions.collections',
    systempermissionsearch: 'system.permission',
    importhistorysearch: 'import.history',
    externalcontactsearch: 'external.contact',
};

/** Box heading translation key for a search route; falls back to `label` when unmapped. */
export function getSearchBoxHeadingKey(routeDef: IRouteDefinition | null | undefined): string {
    if (!routeDef?.id) {
        return '';
    }
    const conceptualKey = ROUTE_ID_TO_SEARCH_KEY[routeDef.id];
    if (conceptualKey) {
        const mapped = searchKeyMap[conceptualKey];
        if (mapped) {
            return mapped;
        }
    }
    const label = routeDef.label;
    return (typeof label === 'function' ? label() : label) ?? '';
}
